<template>
  <div class="slide-out-dimensions-tab" :class="containerClasses">
    <div
      v-if="selectedDimensions && selectedDimensions.length"
      class="pre-selected"
    >
      <Checkbox
        v-for="dimension in selectedDimensions"
        v-model="dimension.checked"
        class="option"
        :key="`selected-${dimension.key}`"
        :name="dimension.value"
        @input="handleSelect(dimension, $event)"
      >
        {{ dimension.key }}
      </Checkbox>
    </div>
    <div
      v-for="(dimensions, category) in categoryMap"
      class="options"
      :key="category"
    >
      <span class="label">{{ category }}</span>
      <Checkbox
        v-for="dimension in dimensions"
        v-model="dimension.checked"
        class="option"
        :key="dimension.key"
        :name="dimension.value"
        :disabled="dimension.disabled"
        @input="handleSelect(dimension, $event)"
      >
        {{ dimension.key }}
      </Checkbox>
    </div>
  </div>
</template>
<script>
import { Checkbox } from '@mikmak/components';

export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
    dimensions: {
      type: Array,
    },
  },
  components: {
    Checkbox,
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  computed: {
    containerClasses() {
      return {
        error: this.error,
      };
    },
    categoryMap() {
      return this.dimensions.reduce((map, d) => {
        d.checked = this.localValue.find(v => v.key === d.key) !== undefined;
        const categoryDimensions = map[d.category];

        map[d.category] = categoryDimensions ? categoryDimensions.concat([d]) : [d];

        return map;
      }, {});
    },
    selectedDimensions() {
      return this.dimensions.reduce((selected, d) => {
        const isSelected = this.localValue.find(v => v.key === d.key) !== undefined;

        if (d.disabled || !isSelected) {
          return selected;
        }
        d.checked = isSelected;
        selected.push(d);

        return selected;
      }, []);
    },
    error() {
      return !this.selectedDimensions || !this.selectedDimensions.length;
    },
  },
  methods: {
    handleSelect(dimension, val) {
      this.setLocalValue(dimension, val);

      this.$emit('input', this.localValue);
      this.$emit('change', this.localValue);
    },
    setLocalValue(dimension, markChecked) {
      const val = this.localValue.find(v => v.key === dimension.key);

      if (markChecked && !val) {
        this.localValue = this.localValue.concat([dimension]);
      }

      if (!markChecked && val) {
        this.localValue = this.localValue.reduce((values, v) => {
          if (v.key !== dimension.key) {
            values.push(v);
          }

          return values;
        }, []);
      }
    },
  },
  watch: {
    value() {
      this.localValue = this.value;
    },
  },
};
</script>
<style scoped>
.slide-out-dimensions-tab {
  font-family: Lato;
  color: #223448;
  border: 1.5px solid #C1CCD4;
  border-radius: 4px;
}

.slide-out-dimensions-tab.error {
  border: 1.5px solid #F16161;
}

.pre-selected {
  border-bottom: 1.5px solid #C1CCD4;
  padding-bottom: 12px;
}

.options {
  padding-top: 16px;
}

.label,
.option {
  padding: 14px 15px 4px 15px;
}

.label {
  font-weight: bold;
}
</style>
<style>
.slide-out-dimensions-tab svg.disabled + span {
  color: #C1CCD4;
}
</style>
